// The way into a chat (D82): a prominent button in a task group's or a task's page header.
import { ChatsCircle } from "@phosphor-icons/react";
import { Link } from "react-router";

import { useT } from "../i18n";

export function ChatButton({ to }: { to: string }) {
  const t = useT().chat;
  return (
    <Link
      to={to}
      title={t.openHint}
      className="inline-flex h-10 items-center gap-1.5 rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground hover:bg-primary-dark hover:text-primary-foreground"
    >
      <ChatsCircle weight="bold" className="h-4 w-4" /> {t.open}
    </Link>
  );
}
